// extracted by mini-css-extract-plugin
module.exports = {"small":"FavoriteButton_small__Z_hED","middle":"FavoriteButton_middle__ghvYx","favoriteButton":"FavoriteButton_favoriteButton__YzXGS"};